import { z } from "zod";

import type { Operation } from "server/auth/types";

import type { Zapbot } from "../types";

export const allowed: Zapbot["allowed"] = (block) => {
  const operations: Operation[] = [
    {
      type: "query",
      path: "zapbots.list",
      validator: z.any(),
    },
  ];

  if (block.config.zapbotId) {
    operations.push(
      {
        type: "query",
        path: "zapbots.inputs",
        validator: z.object({
          id: z.literal(block.config.zapbotId),
        }),
      },
      {
        type: "mutation",
        path: "zapbots.run",
        validator: z.object({
          body: z.object({
            config: z.record(z.string()),
          }),
        }),
      }
    );
  }

  return operations;
};
